import type { BlogPost } from './types';

export const post: BlogPost = {
  slug: 'over-unders-for-people-with-trust-issues',
  title: 'Over/unders for people with trust issues',
  excerpt:
    'You do not have to believe in either team. You just have to have an opinion about the scoreboard. For some of us, that is healing.',
  author: 'Frankie',
  date: '2026-07-04',
  category: 'Betting Basics',
  evergreen: true,
  tags: ['totals', 'over-under', 'basics', 'pace'],
  body: `# Over/unders for people with trust issues

Some of us have been hurt before. By a quarterback. By a bullpen. By a team that was "due." If picking sides feels like getting back into a relationship you already know the ending of, allow me to introduce the total.

An over/under is a bet on the combined final score of both teams. The book posts a number, say 47.5 in a football game, and you decide whether the two teams together score more than that or less. That is it. You never have to trust anyone. You just have to have an opinion about how the evening goes.

This is the commitment-free zone of betting and I mean that as a compliment. You are not marrying a team. You are betting on the weather.

## The party and the funeral

The over is the fun one, and the book knows it. When you have the over, every score helps you, both teams are your teams, and a garbage-time touchdown is a religious experience. When you have the under, you are the person at the party asking if we can turn the music down. You spend three hours rooting for punts, timeouts, and long, beautiful stretches of nothing. It is miserable company and it cashes more often than it should, precisely because everyone else at the table wants the party.

That is the first trust issue to have: with yourself. Ask whether you like the over because the matchup is genuinely fast, or because watching the under is a personality test you know you will fail.

## What moves a total

The second trust issue is with the number itself. Totals are built from real ingredients: pace, offensive form, injuries, and in outdoor sports, weather that actually matters. Wind does more damage to a football total than most injuries. A getaway-day baseball game with two tired bullpens plays different from a Tuesday in a pitcher's park. You do not need a model. You need to ask what kind of night this actually is before you buy the fireworks package.

And the third trust issue is with keys that jingle. A total that dropped from 49 to 45.5 by kickoff is the market telling you something changed. Chasing the over anyway because the teams "can score" is the totals version of "he's different now." Sometimes true. Expensive to assume.

## House rules

House rules, from someone who has felt feelings about a meaningless free throw at 11:58 p.m.: bet totals small, know why the number is what it is, and never take an over just to make a boring game watchable. That is not a bet. That is paying a cover charge for a party that might not happen.

The under crowd is smug and the over crowd is broke and happy. Pick your fighter. I contain both, usually within the same weekend.`,
};
